import React from 'react';
import SendMessage from './SendMessage';

export default function NewCampaign() {
  return <SendMessage mode="campaign" />;
}
